var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading_content_sty"},[_c('lottie',{staticClass:"lottie_sty",attrs:{"options":_vm.defaultOptions,"height":100,"width":100},on:{"animCreated":_vm.handleAnimation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }